import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import tests from './modules/tests';
import testFlow from './modules/testFlow';
import options from './modules/options';
import user from './modules/user';
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    strict: debug,
    plugins: [
        createPersistedState({
            key: 'easy_test_' + process.env.NODE_ENV,
            paths: ['auth', 'testFlow'],
            fetchBeforeUse: true
        })
    ],
    state: {
        isLoading: false,
        globalNotification: {
            type: null,
            message: null
        }
    },
    modules: {
        auth,
        tests,
        testFlow,
        options,
        user
    },
    mutations: {
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading;
        },
        setGlobalNotification(state, data) {
            state.globalNotification.type = data.type;
            state.globalNotification.message = data.message;
        },
        resetGlobalNotification(state) {
            state.globalNotification.type = null;
            state.globalNotification.message = null;
        }
    },
    getters: {
        isLoading(state) {
            return state.isLoading;
        },
        globalNotification(state) {
            return state.globalNotification;
        }
    }
})
